import { render, staticRenderFns } from "./FilesComponent.vue?vue&type=template&id=77f0834a&scoped=true"
import script from "./FilesComponent.vue?vue&type=script&lang=js"
export * from "./FilesComponent.vue?vue&type=script&lang=js"
import style0 from "./FilesComponent.vue?vue&type=style&index=0&id=77f0834a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f0834a",
  null
  
)

export default component.exports